import { colors } from 'theme/colors';
import svgs from 'theme/svgs';

const passwordStrengthMeterSharedStyle = {
  textColor: colors['content-primary'],
  backgroundColor: colors.lightGrey,
  radius: '8px',
  padding: '8px 13px',
  fontSize: '12px',
  lineHeight: 1.25,
  height: '31px',
};

const inlineErrorSharedStyle = {
  textColor: colors.alertRed,
  backgroundColor: 'none',
  radius: '0px',
  fontSize: '12px',
  lineHeight: '17px',
  margin: '0 0',
  padding: '9px 0',
  icon: '⚠️',
};

export const styles = {
  contentWidth: {
    desktop: '480px',
    tablet: '640px',
  },
  submitButton: {
    backgroundColor: colors.brightGreen,
    textColor: colors['content-primary'],
    fontSize: '16px',
    lineHeight: '22px',
    margin: '24px auto 5px',
  },
  passwordStrengthMeter: {
    strong: {
      ...passwordStrengthMeterSharedStyle,
      backgroundColor: colors.lightGreen,
    },
    medium: passwordStrengthMeterSharedStyle,
    weak: passwordStrengthMeterSharedStyle,
    margin: '0',
    default: {
      padding: '0 1px',
      textColor: colors['content-primary'],
      fontSize: '12px',
      backgroundColor: colors.white,
    },
  },
  inlineError: inlineErrorSharedStyle,
  generalText: {
    textColor: colors.darkGrey,
    backgroundColor: 'none',
    radius: '0px',
    fontSize: '12px',
    lineHeight: '1.25',
    margin: '0 0',
    padding: '8px 7px 7px 4px',
  },
  inputs: {
    height: '64px',
    borderRadius: '1rem',
    borderWidth: '2px',
    border: `solid 2px ${colors.lightGrey}`,
    colors: {
      active: colors.brightGreen,
      backgroundError: colors.tint.alertRed.a10,
      backgroundColor: 'transparent',
      placeholder: colors.darkGrey,
      inactive: colors.lightGrey,
      error: colors.alertRed,
    },
    padding: '28px 12px 12px',
    lineHeight: '22px',
    icon: {
      right: '10px',
      top: '20px',
      left: '0',
      topInShowHideVariant: '-2px',
    },
    showHideText: {
      right: '15px',
      top: '22px',
    },
    readOnlyMode: {
      height: '64px',
      valueColor: colors.darkGrey,
      margin: '32px 10px 16px',
      border: `2px solid ${colors.lightGrey}`,
      borderRadius: '1rem',
    },
    actionClickable: {
      color: colors.darkGreen,
      top: '21px',
      right: '16px',
    },
    position: 'relative',
  },
  label: {
    fontSize: '14px',
    color: colors.darkGrey,
    fontWeight: '500',
    margin: '0 0 5px',
    position: 'absolute',
    transition: '0.2s ease all',
    lineHeight: '20px',
    selectInput: { transition: '0.05s ease all' },
    empty: { top: '22px', left: '13px', fontSize: '16px' },
    focusedOrFilled: { top: '8px', left: '13px', fontSize: '12px' },
  },
  titles: {
    fontWeight: '600',
    fontSize: '30px',
    lineHeight: '38px',
    paddingBottom: '0',
  },
  descriptionText: {
    fontSize: '16px',
    lineHeight: '22px',
  },
  inputWrapper: {
    margin: '-16px 8px',
  },
  rowWrapper: {
    margin: '0px -8px',
  },
  ssnPage: {
    lockIcon: svgs.lock,
    inputs: { backgroundColor: colors.white },
    inputSurroundBox: {
      backgroundColor: colors.lightGrey,
      border: `none`,
      borderRadius: '8px',
      marginBottom: '30px',
      padding: '8px 11px',
    },
    subText: {
      color: colors.darkGrey,
      fontSize: '12px',
      lineHeight: '17px',
      paddingLeft: '0',
      marginTop: '-8px',
    },
    inlineError: {
      margin: '-30px 0 0',
    },
  },
  addressAutocomplete: {
    clearButton: {
      top: '9px',
      right: '2px',
      width: '47px',
      src: svgs.close,
    },
    loader: {
      top: '20px',
      right: '16px',
    },
    paddingRight: '50px',
    backgroundColor: colors.white,
    dropdownTop: '58px',
  },
  dropdown: {
    backgroundImage: svgs.dropdownArrowBlurred,
    backgroundPosition: 'calc(100% - 20px) calc(100% - 23px)',
  },
  bottomSheet: {
    overlay: {
      backgroundColor: colors['content-primary'],
      opacity: '0.48',
    },
    backgroundColor: colors.white,
    height: '200px',
    padding: '44px 32px',
    borderRadius: '6px',
  },
  lists: {
    li: {
      listStyleImage: svgs.grayCheck,
    },
  },
};

export default { styles };
